module.exports = __webpack_public_path__ + "static/img/5.cd0c2a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/zh/5.png
// module id = aRlc
// module chunks = 0